import React from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";

const TauriBreadCrumbDropdown = ({
    items,
    onSelect,
    selectedItem,
    id,
    variant,
    className,
    menuClassName,
    toggleClassName,
    placeholder,
}) => {
    return (
        <Dropdown className={className}>
            <Dropdown.Toggle variant={variant} id={id} className={toggleClassName}>
                {selectedItem || placeholder}
            </Dropdown.Toggle>
            <Dropdown.Menu className={menuClassName}>
                {items.map((item, index) => (
                    <Dropdown.Item key={index} onClick={() => onSelect(item.value)}>
                        {item.label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

TauriBreadCrumbDropdown.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
        })
    ).isRequired,
    onSelect: PropTypes.func.isRequired,
    selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.string,
    variant: PropTypes.string,
    className: PropTypes.string,
    menuClassName: PropTypes.string,
    toggleClassName: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
};

TauriBreadCrumbDropdown.defaultProps = {
    variant: "secondary",
    className: "",
    id: "",
    selectedItem: "",
    menuClassName: "",
    toggleClassName: "",
    placeholder: "---Select---", 
};

export default TauriBreadCrumbDropdown;
